import { render, staticRenderFns } from "./SignupCertificateOptions.vue?vue&type=template&id=3f5d22a0"
import script from "./SignupCertificateOptions.vue?vue&type=script&lang=ts"
export * from "./SignupCertificateOptions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports